import { CompanyIcon, Flex, Text } from '@/uicomponents';
import { useAuthStore } from '@/stores/auth-store';

import { Show } from '../show';
import styles from './on-behalf-bar.module.css';

export interface OnBehalfBarProps {
  /** Owning client account name (from the parent campaign). */
  tenantName: string | undefined;
}

/**
 * Wizard strip for DZ create-on-behalf (NPJB-415): "Creating on behalf of" +
 * the client account inherited from the parent campaign. Read-only — the
 * account is chosen once at campaign creation and never changes afterwards.
 * Replaces the global "Viewing as Digitalzone" banner on wizard routes.
 * Internal users only — renders nothing for clients.
 */
export function OnBehalfBar({ tenantName }: Readonly<OnBehalfBarProps>) {
  const isInternal = useAuthStore((s) => s.isInternal);

  return (
    <Show when={isInternal && Boolean(tenantName)}>
      <Flex align='center' gap={12} className={styles.bar}>
        <Text weight='semibold' className={styles.label}>
          Creating on behalf of
        </Text>
        <Flex align='center' gap={4} className={styles.pill}>
          <CompanyIcon className={styles.icon} />
          <Text weight='semibold' variant='caption'>
            {tenantName}
          </Text>
        </Flex>
      </Flex>
    </Show>
  );
}
